export const PageSizeOptions = [10, 20, 50];
export const FileMaxSizeInMB = 5242880;
